import User from "@views/user/User";
import StudentApply from "@views/user/student/StudentApply.vue";
import ClassSgin from "@views/user/student/ClassSgin.vue";
import vacate from "@views/user/student/vacate.vue";

export default [
  {
    path: "/user",
    name: "User",
    meta: {
      title: "个人中心",
      keepAlive: true,
      footer: true,
      // backgroundColor: "#2980f7",      
      auth: true
    },
    component: User
  },
  {
    path: "/student/apply",
    name: "Sign",
    meta: {
      title: "学员报名",

      KeepAlive: true,
      footer: true,
      auth: true
    },
    component: StudentApply
  },
  {
    path: "/class_sgin/index",
    name: "ClassSgin",
    meta: {
      title: "班级点名",
      footer: true,
      KeepAlive: true,
      auth: true
    },
    component: ClassSgin
  },
  {
    path: "/class/student/:id",
    name: "ClassStudent",
    meta: {
      title: "班级详情",
      KeepAlive: true,
      // footer: true,
      auth: true
    },
    component: () => import("@views/user/student/ClassStudent.vue")
  },
  {
    path: "/student_manage/index",
    name: "StudentManage",
    meta: {
      title: "学员管理",
      KeepAlive: true,
      footer: true,
      auth: true
    },
    component: () => import("@views/user/student/StudentManage.vue")
  }, 
  {
    path: "/user/binding",
    name: "BindingPhone",
    meta: {
      title: "绑定手机",
      keepAlive: true,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/BindingPhone.vue")
  },
  {
    path: "/user/add_address/:id?",
    name: "AddAddress",
    meta: {
      title: "添加收货地址",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddAddress.vue")
  },
  {
    path: "/user/account",
    name: "UserAccount",
    meta: {
      title: "我的账户",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserAccount.vue")
  },
  {
    path: "/user/add_manage",
    name: "AddressManagement",
    meta: {
      title: "地址管理",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddressManagement.vue")
  },
  {
    path: "/user/poster",
    name: "Poster",
    meta: {
      title: "分销海报",
      keepAlive: false,
      backgroundColor: "#a3a3a3",
      auth: true
    },
    component: () => import("@views/user/promotion/Poster.vue")
  },
  {
    path: "/user/sign",
    name: "Sign",
    meta: {
      title: "签到",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/Sign.vue")
  },
  {
    path: "/user/sign_record",
    name: "SignRecord",
    meta: {
      title: "签到记录",
      keepAlive: true
    },
    component: () => import("@views/user/signIn/SignRecord.vue")
  },
  {
    path: "/user/cash",
    name: "UserCash",
    meta: {
      title: "提现",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/user/audit",
    name: "CashAudit",
    meta: {
      title: "提现审核",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashAudit.vue")
  },
  {
    path: "/user/promoter_order",
    name: "PromoterOrder",
    meta: {
      title: "推广人订单",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterOrder.vue")
  },
  {
    path: "/user/promoter_list",
    name: "PromoterList",
    meta: {
      title: "推广人列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterList.vue")
  },
  {
    path: "/user/user_promotion",
    name: "UserPromotion",
    meta: {
      title: "我的推广",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserPromotion.vue")
  },
  {
    path: "/user/bill/:types?",
    name: "UserBill",
    meta: {
      title: "账单明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserBill.vue")
  },
  {
    path: "/user/cashrecord",
    name: "CashRecord",
    meta: {
      title: "提现记录",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashRecord.vue")
  },
  {
    path: "/user/commission",
    name: "CommissionDetails",
    meta: {
      title: "佣金明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionDetails.vue")
  },
  {
    path: "/user/integral",
    name: "Integral",
    meta: {
      title: "积分详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/Integral.vue")
  },
  {
    path: "/user/LessonList/:uid",
    name: "LessonList",
    meta: {
      title: "课时详情",
      keepAlive: true,
      footer: true,
      auth: true
    },
    component: () => import("@views/user/student/LessonList.vue")
  },
  {
    path: "/user/vip",
    name: "UserVip",
    meta: {
      title: "会员中心",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserVip.vue")
  },
  {
    path: "/user/data",
    name: "PersonalData",
    meta: {
      title: "个人资料",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/PersonalData.vue")
  },
  {
    path: "/user/user_coupon",
    name: "UserCoupon",
    meta: {
      title: "我的优惠券",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/coupon/UserCoupon.vue")
  },
  {
    path: "/user/get_coupon",
    name: "GetCoupon",
    meta: {
      title: "领取优惠券",
      keepAlive: true
    },
    component: () => import("@views/user/coupon/GetCoupon.vue")
  },
  {
    path: "/user/user_cash",
    name: "UserCash",
    meta: {
      title: "申请提现",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/customer/list/:productId?",
    name: "CustomerList",
    meta: {
      title: "客服列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/CustomerList.vue")
  },
  {
    path: "/user/Recharge",
    name: "Recharge",
    meta: {
      title: "余额充值",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/Recharge.vue")
  },
  {
    path: "/user/promoter_rank",
    name: "PromoterRank",
    meta: {
      title: "推广人排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterRank.vue")
  },
  {
    path: "/user/commission/rank",
    name: "CommissionRank",
    meta: {
      title: "佣金排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionRank.vue")
  },
  {
    path: '/user/studentClassList/:uid',
    name: 'SutdentClassList',
    meta: {
      title: "今日课程表",
      keepAlive: true,
      footer: true,
      auth: true
    },
    component: () => import("@views/user/student/studentClassList")
  },
  {
    path: '/user/student/a/lensson/:uid',
    name: 'StudentALesson',
    meta: {
      title: "课程表",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: () => import("@views/user/student/studentALesson")
  },
  {
    path: '/user/student/lesson/list/:uid',
    name: 'StudetLessonList',
    meta: {
      title: "剩余课时",
      keepAlive: true,
      footer: true,
      auth: true
    },
    component: () => import("@views/user/student/studentLessonList")
  },
  {
    path: '/user/student/taskOf/:uid',
    name: 'StudentTaskOf',
    meta: {
      title: "添加请假单",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: () => import("@views/user/student/StudentTaskOf")
  },
  {
    path: '/user/student/rest/list/:uid',
    name: 'SutdentRestList',
    meta: {
      title: "请假单",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: () => import('@views/user/student/studentRestList')
  },
  {
    path: '/teacher/info',
    name: 'Teacher',
    meta: {
      title: "老师信息",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: () => import('@views/user/student/Teacher')
  },

  {
    path: '/user/workEvaluate/:uid',
    name: 'WorkEvaluate',
    meta: {
      title: "作业点评",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: () => import('@components/WorkEvaluate')
  },
  {
    path: '/user/studentWork/:uid',
    name: 'StudentWork',
    meta: {
      title: "学生作品",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: () => import('@views/user/student/StudentWorks')
  },
  {
    path: '/user/add/studentWorks/:uid',
    name: 'AddWork',
    meta: {
      title: "作品添加",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: () => import('@views/user/student/Work/AddWork')
  },
  {
    path: '/user/workView/:uid',
    name: 'WorkView',
    meta: {
      title: "作品展示",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: () => import('@views/user/student/Work/WorkView')
  },
  {
    path: '/user/test/:uid',
    name: 'test',
    meta: {
      title: "作业点评",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: () => import('@views/test')
  },
  {
    path: '/vacate/info1',
    name: 'vacate',
    meta: {
      title: "请假审批",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: () => import('@views/user/student/vacate.vue')
  },
];
